import { SearchFn } from "../../../../../rest/Search";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { FlagActions } from "../../../../flux/Flag/FlagActions";
import { EditCreateDivisionActions } from "../EditCreateDivisionActions";
import { EditCreateDivisionStore } from "../EditCreateDivisionStore";
import { Command } from "../../../../../Command";

export class InitUpsertDivisionCommand implements Command
{
    private readonly errorActions = new ErrorActions();
    private readonly inProgressActions = new FlagActions();
    private readonly editActions = new EditCreateDivisionActions();
    
    constructor(private runSearch: SearchFn, private store: EditCreateDivisionStore, private getDidivionId: () => number, private inProgressDispatchToken: string, private errorDispatchToken: string)
    {
    }
    
    execute = () => {
        this.errorActions.clearError(this.errorDispatchToken); // reset error from previous edit session
        this.inProgressActions .set(this.inProgressDispatchToken);
        this.runSearch({ Name: 'Divisions' })
            .then(res => {
                const { Division: divisions } = res.Entries
                const { ParentId, id } = this.store.getState().draft;
                if(ParentId == null && id == null) {
                    const currDivisionId = this.getDidivionId();
                    const division = divisions.find(d => d.id === currDivisionId);
                    if(division) {
                        this.editActions.setParentDivision(division.id);
                    }
                }
                this.editActions.setDivisionItems(divisions);
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken))
            .then(() => this.inProgressActions.reset(this.inProgressDispatchToken)); // finaly
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/commands/InitUpsertDivisionCommand.ts